
export const SiteConstants = {
    Area: "area",
    Layer: "layer"
};
